<template>
  <div class="public-content platform-message">
    <div class="breadcrumb">发票申请记录</div>
    <div class="right-main">
      <el-form :inline="true" :model="formInline" label-width="130px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="申请单号:">
              <!-- <el-select clearable v-model="formInline.orderNo" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id"></el-option>
              </el-select> -->
              <el-input v-model="formInline.orderNo" placeholder="请输入订单号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台名称:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterByName" filterable placeholder="请输入平台名称">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="发票类型:">
              <el-select v-model="formInline.fapiaoType" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option label="普通电子发票" value="ELECTRONIC"></el-option>
                <el-option label="增值税发票" value="VAT_SPECIAL"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="状态:">
              <el-select v-model="formInline.fapiaoStatus" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option label="已开票" value="INVOICED"></el-option>
                <el-option label="未开票" value="APPLY"></el-option>
                <el-option label="开票中" value="INVOICING"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="申请日期:" class="el-date-width">
              <el-date-picker clearable v-model="date" type="daterange" align="left" unlink-panels range-separator="至" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期"
                :picker-options="pickerOptions" format="yyyy - MM - dd " value-format="yyyy-MM-dd" @change="changeDate">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 0, searchInvoice(queryInfo)" round>查询</el-button>
            <el-button class="search-ok" @click="exportExcel()" round>导出Excel</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="fapiaoOrderno" label="申请单号" min-width="170px"></el-table-column>
          <el-table-column prop="store.code" label="平台号"></el-table-column>
          <el-table-column prop="store.name" label="平台名称"></el-table-column>
          <el-table-column prop="totalAmount" label="发票金额"></el-table-column>
          <el-table-column prop="fapiaoType" label="发票类型">
            <template slot-scope="scope"> {{ $config.FapiaoType[scope.row.fapiaoType] }} </template>
          </el-table-column>
          <el-table-column prop="fapiaoTitle" label="发票抬头"></el-table-column>
          <el-table-column prop="buyerCert.taxno" label="税务登记号" min-width="180px"></el-table-column>
          <el-table-column prop="store.name" label="状态">
            <template slot-scope="scope"> {{ $config.FapiaoStatus[scope.row.fapiaoStatus] }} </template>
          </el-table-column>
          <el-table-column prop="dateCreated" label="申请日期" min-width="140px"></el-table-column>
          <el-table-column prop="auditStatus" label="操作">
            <template slot-scope="scope">
              <div class="color-blue" @click="kaipiao(scope)" v-show="scope.row.fapiaoStatus === 'APPLY'">开票</div>
              <div class="color-blue" @click="openPdf(scope.row.receipt)" v-show="scope.row.fapiaoType === 'ELECTRONIC' && scope.row.fapiaoStatus === 'INVOICED'">查看</div>
              <!-- 纸质 -->
              <div class="color-blue" v-show="scope.row.fapiaoType === 'VAT_SPECIAL' && scope.row.fapiaoStatus === 'INVOICED' && scope.row.express"
                @click="$refs.expressDialog.show(scope.row.express, scope.row.address.phone)">查看快递</div>
              <div class="color-blue" v-show="scope.row.fapiaoType === 'VAT_SPECIAL' && scope.row.fapiaoStatus === 'INVOICED' && !scope.row.express"
                @click="$refs.addExpressDialogVue.show(scope.row.fapiaoId)">邮寄发票</div>
              <div class="color-blue" v-show="scope.row.fapiaoType === 'VAT_SPECIAL'" @click="$refs.addressDialogVue.show(scope.row.addressId)">邮寄地址</div>
              <!-- <br v-show="scope.row.fapiaoType === 'VAT_SPECIAL' && scope.row.fapiaoStatus === 'INVOICED' && !scope.row.express"> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <!-- <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination> -->
      <div class="vm-pagination">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum + 1" :page-size="queryInfo.pageSize"
          layout="prev, pager, next, sizes,jumper" :total="queryInfo.total" :page-sizes="[10, 50, 100]">
        </el-pagination>
      </div>
    </div>
    <kaipiaoDialog ref="kaipiaoDialog" @kaipiaoSuccess="queryInfo.pageNum = 0, searchInvoice(queryInfo)"></kaipiaoDialog>
    <addressDialogVue ref="addressDialogVue"></addressDialogVue>
    <addExpressDialogVue ref="addExpressDialogVue" @success='queryInfo.pageNum = 0, searchInvoice(queryInfo)'></addExpressDialogVue>
    <expressDialog ref="expressDialog"></expressDialog>
  </div>
</template>
<script>
import expressDialog from '@/components/Dialog/ExpressDialog'
import addExpressDialogVue from './addExpressDialog.vue'
// import VPagination from '@/components/Pagination/index.vue'
import {
  storeQueryListByCode, storeQueryListByName,
  financeReport
} from '@/api/crm'
import { searchInvoice, fapiaoQuery } from '@/api/finance'
import kaipiaoDialog from './kaipiaoDialog.vue'
import addressDialogVue from './addressDialog.vue'
export default {
  name: 'certification-message',
  components: {
    // VPagination, 
    kaipiaoDialog, addressDialogVue, addExpressDialogVue, expressDialog
  },
  data () {
    return {
      storeListByCode: [],
      formInline: {
        dateEnd: '',
        dateStart: '',
        fapiaoStatus: '',
        fapiaoType: '',
        orderNo: '',
        storeId: ''
      },
      date: [
        this.$moment().subtract(6, 'months').format('YYYY-MM-DD'),
        this.$moment().format('YYYY-MM-DD')
      ],
      tableData: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      queryInfo: {
        pageNum: 0, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      }
    }
  },
  created () {
    this.searchInvoice(this.queryInfo)
  },
  methods: {
    openPdf (receipt) {
      window.open(receipt.url ? receipt.url : receipt)
    },
    handleSizeChange (val) {
      this.queryInfo.pageSize = val
      this.changePage(this.queryInfo)
    },
    handleCurrentChange (val) {
      console.log(val)
      this.queryInfo.pageNum = val - 1
      this.changePage(this.queryInfo)
      // this.$emit('changePage', this.queryInfo)
    },
    kaipiao (scope) {
      this.$refs.kaipiaoDialog.show(scope.row)
    },
    filterByName (val) {
      if (val.trim()) {
        storeQueryListByName(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    searchInvoice (val) {
      let param = JSON.parse(JSON.stringify(this.formInline))
      Object.keys(param).forEach((key) => (param[key] === '' || param[key] === null) && delete param[key])
      console.log({ pageNum: val.pageNum, pageSize: val.pageSize, vo: param }, 'hahaha ')
      searchInvoice({ page: val.pageNum, size: val.pageSize, vo: param, descField: 'dateCreated' }).then(async (res) => {
        let fpOrderNoList = []
        if (res.data.success) {
          //  开票中的数据不在列表中展示
          this.tableData = res.data.data.content.map(a => {
            if (a.address) {
              a.address.phone = this.$msg.filterBridal(a.address.phone)
            }
            return a
          })
          this.queryInfo.total = res.data.data.total
          res.data.data.content.forEach(itm => {
            // 开票中
            if (itm.fapiaoStatus === 'INVOICING') {
              fpOrderNoList.push(itm.fapiaoOrderno)
            }
          })
          this.loading = false
          console.log('this.invoiceList', this.invoiceList)
          let order = await fapiaoQuery({ fpOrderNoList: fpOrderNoList })
          if (order.data.success) {
            if (order.data.data) {
              let orderNoList = order.data.data
              this.tableData = res.data.data.content.map(val => {
                let item
                orderNoList.forEach(res => {
                  if (res.c_orderno === val.fapiaoOrderno) {
                    item = {
                      ...val,
                      fapiaoStatus: res.c_status === '2' ? 'INVOICED' : res.c_status === '22' ? 'INVOICE_FAILED' : 'INVOICING',
                      receipt: res.c_url ? res.c_url : ''
                    }
                  }
                })
                console.log('item', item)
                if (item) {
                  return item
                } else {
                  return val
                }
              })
            }
          }
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.searchInvoice(this.queryInfo)
    },
    changeDate (val) {
      if (val) {
        this.formInline.dateStart = val[0]
        this.formInline.dateEnd = val[1]
      } else {
        this.formInline.dateStart = ''
        this.formInline.dateEnd = ''
      }
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      financeReport(this.formInline).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = (event) => {
          let a = document.createElement('a')
          let _fileName = ''
          if (this.formInline.dateStart && this.formInline.dateEnd) {
            _fileName = '发票申请明细表' + this.formInline.dateStart + '-' + this.formInline.dateEnd + '.xls'
          } else {
            _fileName = '发票申请明细表' + this.$moment(new Date()).format('YYYY-MM-DD') + '.xls'
          }
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.vm-pagination {
  width: 100%;
  box-sizing: border-box;
  padding: 15px 0;
  display: flex;
  justify-content: center;

  @{deep}.el-pagination {
    .el-pager {
      li {
        background: #fff;
        min-width: 35px;
        height: 35px;
        line-height: 35px;
        border-radius: 3px;
        border: 1px solid #e4e4e4;
      }

      .active {
        background-color: #666666 !important;
        color: #fff;
      }
    }

    button {
      line-height: 35px;
      height: 35px;
    }

    .el-input--mini .el-input__inner,
    .el-pagination__jump {
      height: 35px;
      line-height: 35px;
    }
  }
}

@{deep} .data-list .el-table tr td {
  height: 40px !important;
  padding: 0 !important;
}
</style>
